'use strict';

var React = require('react')
var FormatMessage = require('react-globalize').FormatMessage;

function isEmpty(ob){
  for(var i in ob)
  { return false;}
  return true;
}

var ErrorBox = React.createClass({
  getInitialState: function() {
    return {
      visibility:"hidden",
      errorlist: {}
    }
  },
  getDefaultProps: function() {
    return {
      locale:"es",
      width: "col-md-10 col-md-offset-1",
      errorlist: {}
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (isEmpty(newProps.errorlist)) {
      this.setState({visibility: "hidden"});
    }
    else{
      this.setState({visibility: "show"});
    }
    this.setState({errorlist: newProps.errorlist});;
  },
  render: function () {
    var itemList = [];
    var i = 0;
    for(var key in this.state.errorlist) {

      itemList.push(<li key = {i} ><i className="fa fa-exclamation-triangle"></i>  <FormatMessage locale={this.props.locale} path={"errorMessages/"+this.state.errorlist[key]} /></li>
    );
      i++;
    }

    return (
      <div className="row">
      <div className={"col-xs-12 "+this.props.width +" "+this.state.visibility}>
      <div className={"bg-danger alert alert-danger "} role="alert">
      <ul className="list-unstyled">
      {itemList}
      </ul>
      </div>
      </div>
      </div>
    );
  }
});

module.exports = ErrorBox



// WEBPACK FOOTER //
// ./js/errorBox.js